import { useState } from 'react'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate';
import { useAdminCity, useAdminDailyReport, useApartmentListForCourse } from '../../../assets/api/useAdminApi';
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField';
import { DateFormField } from '../../../shared/components/formfields/DataFormField';

const DailyReports = () => {
    const [filters, setFilters] = useState({});
    const [cityId, setCityId] = useState("")
    const [searchCity,setSearchCity]=useState("")
    const { data: dailyReports, isLoading: isDailyReportLoading } = useAdminDailyReport(filters)
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse({city_id:cityId});
    const { data: cityList, isLoading: isCityLoading } = useAdminCity({search:searchCity},{ enabled: true })

    const ApartmentOptions = apartmentList?.data
        ?.filter((item) => item?.is_verified !== 1)
        .map((item) => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        })) || [];

    const CityOptions = cityList?.data?.map((city) => ({
        id: city?.id,
        label: city?.city_name,
        value: city?.city_name,
    })) || []

    const dailyReportColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "attendance_count",
            headerName: "Attendance Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "order_count",
            headerName: "Order Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "enquiry_count",
            headerName: "Enquiry Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }
    ];

    return (
        <>
            <TableFilterTemplate
                title="Daily Report"
                columns={dailyReportColumn}
                rowsData={dailyReports?.data || []}
                isLoading={isDailyReportLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="city_id"
                                component={IdAutoCompleteField}
                                options={CityOptions}
                                label="Select City"
                                isLoading={isCityLoading}
                                onValueChange={(val) => { setCityId(val?.id) }}
                                onSearchChange={(val)=>{setSearchCity(val)}}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="apartment_id"
                                component={IdAutoCompleteField}
                                options={ApartmentOptions}
                                label="Select Apartment"
                                isLoading={isLoadingApartmentList}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="from"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values?.to || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to"
                                component={DateFormField}
                                label="End Date"
                                minDate={values?.from || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default DailyReports